import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getDetailPackageShipment } from '../services/package'

export const getPackageDetail = createAsyncThunk('package/getPackageDetail', async (packageId) => {
  const params = {
    'include': 'packaging,creator,updater,images,order',
    timestamp: `${new Date().getTime()}`
  }
  const response = await getDetailPackageShipment(packageId, params)
  return response
}
)

const packageDetail = createSlice({
  name: 'package_detail',
  initialState: {
    isLoadingPackage: true,
    info_package: {
      name: '',
      courier_name: '',
      courier_name_slug: '',
      order_code: '',
      order_id: null,
      tracking_code: '',
      tracking_code_courier: '',
      total_cbm: 0,
      total_net_weight: 0,
      total_weight: 0
    },
    package_items: [],
  },
  reducers: {
    stateDetailPackage: (state, action) => {
      state.isLoadingPackage = action.payload.isLoadingPackage
      state.info_package = action.payload.info_package
      state.package_items = action.payload.package_items
    },
    updateInformationPackage: (state, action) => {
      state.info_package = action.payload
    },
    updatePackageItems: (state, action) => {
      state.package_items = action.payload
    }
  },
  extraReducers: {
    [getPackageDetail.pending]: (state) => {
      state.isLoadingPackage = true
    },
    [getPackageDetail.fulfilled]: (state, action) => {
      state.info_package = setGeneral(action.payload)
      state.package_items = setPackageItems(action.payload)
      state.isLoadingPackage = false
    },
    [getPackageDetail.rejected]: (state) => {
      state.isLoadingPackage = false
    }
  }
})

const countTotalCBM = (dataPackage) => {
  let totalCBM = 0
  if (dataPackage.length > 0) {
    const countData = dataPackage.reduce((accumulator, val) => {
      let calculateDimens = 0
      const packageDimension = val.attributes.dimensions

      const findHeight = packageDimension.find(val => val.label === 'height').value
      const findWidth = packageDimension.find(val => val.label === 'width').value
      const findLength = packageDimension.find(val => val.label === 'length').value

      if (val.attributes.dimension_unit === 'meters') {
        calculateDimens = Number(findWidth) * Number(findHeight) * Number(findLength)
      } else if (val.attributes.dimension_unit === 'inchs') {
        calculateDimens = (Number(findWidth) / 39.37) * (Number(findHeight) / 39.37) * (Number(findLength) / 39.37)
      } else if (val.attributes.dimension_unit === 'cms') {
        calculateDimens = (Number(findWidth) / 100) * (Number(findHeight) / 100) * (Number(findLength) / 100)
      } 

      return accumulator + (calculateDimens * val.attributes.package_qty)
    }, 0)

    totalCBM = countData
  }
  return totalCBM % 1 === 0 ? totalCBM : totalCBM.toFixed(4)
}

const setGeneral = (payload) => {
  const attributes = payload.data.attributes
  const includedPackage = Object.values(payload.included.packaging) || []
  const includedOrder = payload.included.order || []

  const getDataOrderCode = (orderId, included) => {
    let orderCode = ''
    const findOrder = included[orderId]
    if (findOrder) {
      orderCode = findOrder.attributes.order_code
    }
    return orderCode
  }

  const remapData = {
    name: attributes.name,
    courier_name: attributes.courier_name,
    courier_name_slug: attributes.courier_name_slug,
    order_code: attributes.order_id !== null ? getDataOrderCode(attributes.order_id, includedOrder) : '',
    order_id: attributes.order_id,
    tracking_code: attributes.tracking_code,
    tracking_code_courier: attributes.tracking_code_courier,
    total_cbm: countTotalCBM(includedPackage),
    total_net_weight: includedPackage.reduce((count, val) => count + (val.attributes.net_weight * val.attributes.package_qty), 0),
    total_weight: includedPackage.reduce((count, val) => count + (val.attributes.gross_weight * val.attributes.package_qty), 0)
  }

  return remapData
}

const setPackageItems = (payload) => {
  const attributes = payload.data.attributes
  const includedPackage = Object.values(payload.included.packaging) || []
  const pickIncludedCreator = payload.included.creator || []
  const pickIncludedUpdater = payload.included.updater || []

  const getDataUser = (userId, included) => {
    let data = null
    const findUser = included[userId]
    if (findUser) {
      data = {
        id: findUser.attributes.id,
        name: findUser.attributes.name
      }
    }
    return data
  }

  const remapData = includedPackage.map((val, index) => {
    const data = {
      id: val.attributes.id,
      marks: val.attributes.marks,
      package_qty: val.attributes.package_qty,
      order_items: [],
      package_type: val.attributes.package_type,
      item_qty: val.attributes.item_qty,
      net_weight: val.attributes.net_weight,
      gross_weight: val.attributes.gross_weight,
      dimensions: val.attributes.dimensions,
      unit_dimension: val.attributes.dimension_unit,
      cbm: countTotalCBM([includedPackage[index]]),
      total_cbm : Number(countTotalCBM([includedPackage[index]])) * val.attributes.package_qty,
      total_net_weight: val.attributes.net_weight * val.attributes.package_qty,
      total_gross_weight: val.attributes.gross_weight * val.attributes.package_qty,
      images: null,
      created_at: val.attributes.created_at,
      updated_at: val.attributes.updated_at,
      creator: attributes.created_by !== null ? getDataUser(attributes.created_by, pickIncludedCreator) : null,
      updater: attributes.updated_by !== null ? getDataUser(attributes.updated_by, pickIncludedUpdater) : null
    }
    return data
  })
  return remapData
}

export const { stateDetailPackage, updateInformationPackage, updatePackageItems } = packageDetail.actions
export default packageDetail.reducer